export default "__VITE_ASSET__ChW5dDD0__"